import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { FadeUp, InviewMaskLine } from "../components/Reveal";
import InquiryForm from "../components/InquiryForm";
import { MailIcon, PhoneIcon } from "../components/ContactIcons";
import { WHATSAPP_PRIMARY, WHATSAPP_SECONDARY, waLink, LEGAL_NAME, LICENSE_NUMBER, ADDRESS } from "../siteConfig";

export default function Contact() {
  const { t } = useLang();
  const paths = [
    { key: "dealerCard", to: "/dealers", test: "contact-path-dealer" },
    { key: "privateCard", to: "/private-clients", test: "contact-path-private" },
  ];
  return (
    <div className="bg-[#050607]" data-testid="contact-page">
      <section className="px-5 md:px-10 pt-40 pb-16 md:pt-48 md:pb-20">
        <FadeUp><div className="eyebrow mb-8">{t("contact.eyebrow")}</div></FadeUp>
        <h1 className="font-display text-[36px] sm:text-[54px] lg:text-[68px] text-[#F3F3F0] max-w-5xl">
          {t("contact.title").split("\n").map((l, i) => <InviewMaskLine key={i} delay={0.2 + i * 0.14}>{l}</InviewMaskLine>)}
        </h1>
        <FadeUp delay={0.35}><p className="mt-8 text-[15px] text-[#999995]">{t("contact.sub")}</p></FadeUp>
      </section>

      <section className="px-5 md:px-10 pb-20 grid grid-cols-1 md:grid-cols-2 gap-5 border-b border-white/10 pb-20">
        {paths.map((p, i) => (
          <FadeUp key={p.key} delay={i * 0.08} className="h-full">
            <Link to={p.to} data-testid={p.test} className="group flex flex-col justify-between h-full border border-white/10 hover:border-white/30 transition-colors duration-500 p-8 md:p-10 bg-[#090A0B]">
              <h2 className="font-display text-[24px] md:text-[32px] text-[#F3F3F0] mb-4">{t(`contact.${p.key}.t`)}</h2>
              <div>
                <p className="text-[13px] leading-relaxed text-[#8A8A86] mb-8 max-w-sm">{t(`contact.${p.key}.d`)}</p>
                <span className="btn justify-between group-hover:bg-white/[0.05]">{t(`contact.${p.key}.btn`)}<span aria-hidden="true">→</span></span>
              </div>
            </Link>
          </FadeUp>
        ))}
      </section>

      <section className="px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-2 gap-14">
        <div>
          <FadeUp><div className="eyebrow mb-8">{t("contact.directTitle")}</div></FadeUp>
          <div className="space-y-8">
            <FadeUp>
              <div>
                <div className="field-label">{t("contact.emailLabel")}</div>
                <a href="mailto:info@veyrone.es" data-testid="contact-email" className="flex items-center gap-3 font-display text-[20px] md:text-[26px] text-[#F3F3F0] link-line w-fit py-1">
                  <span className="text-[#D1C7BD]"><MailIcon size={20} /></span>
                  info@veyrone.es
                </a>
              </div>
            </FadeUp>
            <FadeUp delay={0.08}>
              <div>
                <div className="field-label">{t("contact.phoneLabel")}</div>
                <div className="space-y-4">
                  <div>
                    <div className="mono text-[9px] tracking-[0.16em] text-[#666663] uppercase mb-1">{t("nx.contact.spainOffice")}</div>
                    <a href={waLink(WHATSAPP_PRIMARY, t("whatsapp.msg"))} target="_blank" rel="noopener noreferrer" data-testid="contact-phone-1" className="flex items-center gap-3 font-display text-[20px] md:text-[26px] text-[#F3F3F0] link-line w-fit py-1">
                      <span className="text-[#D1C7BD]"><PhoneIcon size={20} /></span>
                      +34 622 181 686
                    </a>
                  </div>
                  <div>
                    <div className="mono text-[9px] tracking-[0.16em] text-[#666663] uppercase mb-1">{t("nx.contact.dubaiOffice")}</div>
                    <a href={waLink(WHATSAPP_SECONDARY, t("whatsapp.msg"))} target="_blank" rel="noopener noreferrer" data-testid="contact-phone-2" className="flex items-center gap-3 font-display text-[20px] md:text-[26px] text-[#F3F3F0] link-line w-fit py-1">
                      <span className="text-[#D1C7BD]"><PhoneIcon size={20} /></span>
                      +34 639 341 794
                    </a>
                  </div>
                </div>
              </div>
            </FadeUp>
            <FadeUp delay={0.14}>
              <div className="mono text-[10px] text-[#666663] leading-relaxed space-y-1 border-t border-white/10 pt-6" data-testid="contact-legal-info">
                <div>{LEGAL_NAME}</div>
                <div>{t("nx.contact.licence")}: {LICENSE_NUMBER}</div>
                <div>{ADDRESS}</div>
              </div>
            </FadeUp>
          </div>
        </div>
        <div>
          <FadeUp><div className="eyebrow mb-5">{t("contact.formTitle")}</div></FadeUp>
          <FadeUp delay={0.06}><h2 className="font-display text-[26px] md:text-[34px] text-[#F3F3F0] mb-5 max-w-md">{t("forms.invite")}</h2></FadeUp>
          <div className="mt-10">
            <InquiryForm path="general" />
          </div>
        </div>
      </section>
    </div>
  );
}
